import { createSlice } from '@reduxjs/toolkit';

const rafflesDataSlice = createSlice({
  name: 'raffles',
  initialState: {
    rafflesData: {},
    rafflesVersions: [],
    rafflesWinnersData: [],
    rafflesLuckyNumbers: []
  },
  reducers: {
    setRafflesData(state, action) {
      state.rafflesData = action.payload;
    },
    setRafflesVersions(state, action) {
      state.rafflesVersions = action.payload;
    },
    setRafflesWinnersData(state, action) {
      state.rafflesWinnersData = action.payload;
    },
    setRafflesLuckyNumbers(state, action) {
      state.rafflesLuckyNumbers = action.payload;
    }
  },
});

export const { setRafflesData, setRafflesVersions, setRafflesWinnersData, setRafflesLuckyNumbers } = rafflesDataSlice.actions;

export default rafflesDataSlice.reducer;